<header class="main">
  <div class="container">
    <img class="mobile img-fluid wow fadeIn" src="assets/house-baner-mobile.png">
    <img class="normal img-fluid wow fadeIn" src="assets/house-baner-small.png">
    <img class="large img-fluid wow fadeIn " src="assets/house-baner-normal.png">
  </div>
</header>

